import React from "react";
import ReactDOM from "react-dom";
import App from "./components/main/App";

import ConnectReducers from "./context/ConnectReducers";
import { BrowserRouter as Router } from "react-router-dom";

ReactDOM.render(
  <ConnectReducers>
    <Router>
      <App />
    </Router>
  </ConnectReducers>,
  document.getElementById("root")
);
